(function () {
  "use strict";
  var root = document.querySelector("[data-aob-root]");
  if (!root) return;
  var dataNode = document.querySelector("[data-aob-data]"),
    Core = window.AOBuilderCore,
    Logos;
  var app = root.querySelector("[data-aob-app]"),
    fatal = root.querySelector("[data-aob-fatal]");
  var state = { sets: [], note: "", checkoutError: "", busy: false },
    fileUrls = [];
  var data;
  try {
    data = JSON.parse(dataNode.textContent);
    if (!Core || !window.AOBuilderLogos) throw new Error("Core module did not load");
  } catch (error) {
    fatal.hidden = false;
    fatal.textContent = "The order builder could not load. Please refresh or contact us.";
    return;
  }
  data.logos.sort(sortOrder);
  data.locations.sort(sortOrder);
  data.backgrounds.sort(sortOrder);
  if (data.settings.missingProducts) {
    fatal.hidden = false;
    fatal.textContent = "Ordering is temporarily unavailable while this builder is configured.";
  }
  app.hidden = false;
  var mainGrid = root.querySelector("[data-aob-main-locations]"),
    extraGrid = root.querySelector("[data-aob-extra-locations]");
  var firstSetNode = root.querySelector("[data-aob-first-set]"),
    extraSetsNode = root.querySelector("[data-aob-extra-sets]");
  var setsNode = root.querySelector("[data-aob-first-set]").parentElement,
    extrasNode = root.querySelector("[data-aob-extras]");
  var notesNode = root.querySelector("[data-aob-notes]"),
    summaryNode = root.querySelector("[data-aob-summary]");
  var mobile = root.querySelector("[data-aob-mobile]"),
    DRAFT_KEY = "ao-builder-draft-v1";
  var picker = root.querySelector("[data-aob-picker]"),
    pickerTarget = null,
    pickerTrigger = null;

  function sortOrder(a, b) {
    return Number(a.sort_order || 0) - Number(b.sort_order || 0);
  }
  function esc(value) {
    var d = document.createElement("div");
    d.textContent = value == null ? "" : String(value);
    return d.innerHTML;
  }
  function money(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2),
      format = data.settings.moneyFormat || "${{amount}}";
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","));
  }
  function productPrice(key) {
    return data.products[key] ? money(data.products[key].price) : "";
  }
  Logos = window.AOBuilderLogos({ core: Core, esc: esc, price: productPrice });
  function freshSet(location, number) {
    return {
      location: location,
      number: number || "",
      background: "none",
      left: { type: "none" },
      right: { type: "none" },
      direction: "",
      mounting: "",
    };
  }
  function sanitizeSet(existing, location) {
    var clean = freshSet(location, existing && existing.number);
    if (!existing) return clean;
    if (location.allow_background) clean.background = existing.background || "none";
    if (location.allow_logos) {
      clean.left = existing.left || { type: "none" };
      clean.right = existing.right || { type: "none" };
    }
    if (location.allow_direction) clean.direction = existing.direction || "";
    if (location.kind === "plaque") clean.mounting = existing.mounting || "";
    return clean;
  }
  function optionCard(location, action, selected) {
    var key =
      location.kind === "plaque"
        ? "housePlaque"
        : location.kind === "small_mailbox"
          ? "smallMailboxTiles"
          : action === "select"
            ? "firstLocation"
            : "additionalLocation";
    return (
      '<button type="button" class="aob__option" data-action="' +
      action +
      '" data-location="' +
      data.locations.indexOf(location) +
      '" aria-pressed="' +
      !!selected +
      '">' +
      (location.image ? '<img src="' + esc(location.image) + '" alt="" loading="lazy">' : "") +
      '<span class="aob__option-body"><span class="aob__option-title">' +
      esc(location.name) +
      "</span>" +
      (location.description ? '<span class="aob__option-copy">' + esc(location.description) + "</span>" : "") +
      '<span class="aob__price">' +
      (action === "add" ? "Add · " : "") +
      productPrice(key) +
      "</span></span></button>"
    );
  }
  function renderLocationCards() {
    mainGrid.innerHTML = data.locations
      .filter(function (x) {
        return x.main_option;
      })
      .map(function (x) {
        return optionCard(x, "select", state.sets[0] && state.sets[0].location.name === x.name);
      })
      .join("");
    extraGrid.innerHTML = data.locations
      .filter(function (x) {
        return x.extra_option;
      })
      .map(function (x) {
        return optionCard(x, "add", false);
      })
      .join("");
  }
  function tileHtml(type, value, image) {
    return (
      '<span class="aob__tile aob__tile--' +
      type +
      '">' +
      (image ? '<img src="' + esc(image) + '" alt="">' : '<span class="aob__tile-char">' + esc(value) + "</span>") +
      (type === "logo" ? "" : '<small class="aob__mark">AddressOnly</small>') +
      "</span>"
    );
  }
  function preview(set, i) {
    var number = set.number || "1234",
      tiles = "";
    function logo(slot) {
      var out = "";
      for (var n = 0; n < Core.logoQty(slot); n++) out += tileHtml("logo", "", slot.preview || slot.image);
      return out;
    }
    tiles += logo(set.left);
    String(number)
      .split("")
      .forEach(function (n) {
        tiles += tileHtml("digit" + (!set.number ? " is-placeholder" : ""), n);
      });
    if (set.direction) tiles += tileHtml(set.direction === "W" ? "direction aob__tile--dir-w" : "direction", set.direction);
    tiles += logo(set.right);
    var bg = set.background !== "none" && set.background ? set.background.color : "transparent";
    var plaque = set.location.kind === "plaque",
      wrapStart = plaque
        ? '<div class="aob__plaque">' +
          '<i class="aob__screw"></i><i class="aob__screw"></i>' +
          '<i class="aob__screw"></i><i class="aob__screw"></i>'
        : "";
    return (
      '<div class="aob__preview' +
      (set.mounting === "Drilled" ? " is-drilled" : "") +
      '" data-kind="' +
      esc(set.location.kind) +
      '" data-preview="' +
      i +
      '">' +
      wrapStart +
      '<div class="aob__paint" style="--paint:' +
      esc(bg) +
      '"><div class="aob__tiles">' +
      tiles +
      "</div></div>" +
      (plaque ? "</div>" : "") +
      "</div>"
    );
  }
  function choices(name, values, selected, price) {
    return (
      '<div class="aob__choices">' +
      values
        .map(function (v) {
          var val = typeof v === "string" ? v : v.value,
            label = typeof v === "string" ? v : v.label;
          return (
            '<label class="aob__choice"><input type="radio" name="' +
            name +
            '" value="' +
            esc(val) +
            '" ' +
            (val === selected ? "checked" : "") +
            "><span>" +
            esc(label) +
            (price && val ? " +" + price : "") +
            "</span></label>"
          );
        })
        .join("") +
      "</div>"
    );
  }
  function backgroundChoices(set, i) {
    var selected =
      set.background === "none"
        ? "none"
        : String(
            data.backgrounds.findIndex(function (x) {
              return x.name === set.background.name;
            }),
          );
    var options = [
      {
        value: "none",
        label: "No paint · Free",
        image: data.settings.noPaintImage || "",
      },
    ].concat(
      data.backgrounds.map(function (x, bi) {
        return {
          value: String(bi),
          label: x.name + " +" + productPrice("paintedBackground"),
          image: x.image,
        };
      }),
    );
    return (
      '<div class="aob__background-grid">' +
      options
        .map(function (item) {
          return (
            '<label class="aob__option"><input type="radio" name="background-' +
            i +
            '" value="' +
            item.value +
            '" ' +
            (item.value === selected ? "checked" : "") +
            ">" +
            (item.image
              ? '<img src="' + esc(item.image) + '" alt="">'
              : '<span class="aob__no-paint" aria-hidden="true">No paint</span>') +
            '<span class="aob__option-body"><span class="aob__option-title">' +
            esc(item.label) +
            "</span></span></label>"
          );
        })
        .join("") +
      "</div>"
    );
  }
  function setHtml(set, i) {
    var occurrence = state.sets.slice(0, i + 1).filter(function (x) {
      return x.location.name === set.location.name;
    }).length;
    var title = set.location.name + (occurrence > 1 ? " — " + occurrence + ordinal(occurrence) + " set" : "");
    var heading =
      i === 0
        ? '<div class="aob__step-title"><span>2</span><div><h2>Design your tiles</h2><p>' +
          esc(title) +
          "</p></div></div>"
        : '<div><p class="aob__eyebrow">Set ' + (i + 1) + "</p><h3>" + esc(title) + "</h3></div>";
    var html =
      '<article class="aob__set" data-set-card="' +
      i +
      '"><header class="aob__set-head">' +
      heading +
      (i ? '<button type="button" class="aob__remove" data-remove="' + i + '">Remove</button>' : "") +
      "</header>" +
      preview(set, i) +
      '<p class="aob__tile-limit" data-tile-limit="' +
      i +
      '" aria-live="polite"></p><div class="aob__set-body">';
    html +=
      '<div class="aob__field"><label for="aob-number-' +
      i +
      '">Your house number</label><input id="aob-number-' +
      i +
      '" type="text" inputmode="numeric" autocomplete="street-address" maxlength="6" value="' +
      esc(set.number) +
      '" data-number="' +
      i +
      '" aria-describedby="number-help-' +
      i +
      '"><p class="aob__helper" id="number-help-' +
      i +
      '">Just the house number, e.g. 2063.</p><p class="aob__error" data-error-for="sets.' +
      i +
      '.number" hidden></p><p class="aob__error" data-error-for="sets.' +
      i +
      '.tiles" hidden></p></div>';
    if (set.location.allow_background)
      html +=
        '<fieldset class="aob__field"><legend class="aob__legend">Painted background <small>Optional</small></legend>' +
        backgroundChoices(set, i) +
        "</fieldset>";
    if (set.location.allow_logos)
      html +=
        '<fieldset class="aob__field"><legend class="aob__legend">Logo tiles <small>Optional · +' +
        productPrice("logoTile") +
        ' each</small></legend><div class="aob__logo-slots">' +
        Logos.panel(set, i, "left") +
        Logos.panel(set, i, "right") +
        '</div><p class="aob__error" data-error-for="uploads" hidden></p></fieldset>';
    if (set.location.allow_direction)
      html +=
        '<fieldset class="aob__field"><legend class="aob__legend">Direction tile <small>Optional · +' +
        productPrice("directionTile") +
        "</small></legend>" +
        choices("direction-" + i, [{ value: "", label: "None" }, "N", "E", "S", "W"], set.direction) +
        "</fieldset>";
    if (set.location.kind === "plaque")
      html +=
        '<fieldset class="aob__field"><legend class="aob__legend">Mounting</legend>' +
        choices("mounting-" + i, ["Construction adhesive", "Drilled"], set.mounting) +
        '<p class="aob__error" data-error-for="sets.' +
        i +
        '.mounting" hidden></p></fieldset>';
    return html + "</div></article>";
  }
  function ordinal(n) {
    return n === 2 ? "nd" : n === 3 ? "rd" : "th";
  }
  function fitPreviews() {
    root.querySelectorAll("[data-preview]").forEach(function (box) {
      var tiles = box.querySelectorAll(".aob__tile").length || 4,
        small = box.dataset.kind === "small_mailbox",
        painted = box.querySelector(".aob__paint").style.getPropertyValue("--paint") !== "transparent";
      var available = box.clientWidth - (box.dataset.kind === "plaque" ? 105 : 46),
        max = small ? 55 : 105;
      // Tile widths needed: the tiles, their hairline gaps, the paint border and some surface either side.
      var units = tiles + (tiles - 1) * 0.015 + (painted ? 0.28 : 0) + (small ? 0 : 0.5);
      var width = Math.max(25, Math.min(max, available / units));
      box.style.setProperty("--tile-w", width + "px");
      box.style.setProperty("--paint-pad", painted ? width * 0.14 + "px" : "0px");
    });
  }
  function renderSets() {
    firstSetNode.innerHTML = state.sets[0] ? setHtml(state.sets[0], 0) : "";
    extraSetsNode.innerHTML = state.sets
      .slice(1)
      .map(function (set, index) {
        return setHtml(set, index + 1);
      })
      .join("");
    extrasNode.hidden = !state.sets.length;
    notesNode.hidden = !state.sets.length;
    mobile.hidden = !state.sets.length;
    requestAnimationFrame(function () {
      fitPreviews();
      updateAllLimits();
    });
  }
  function renderSummary() {
    if (!state.sets.length) {
      summaryNode.innerHTML = '<h2>Your order</h2><p class="aob__helper">Choose a location to begin.</p>';
      return;
    }
    var priced;
    try {
      priced = Core.calculate(state.sets, data.products);
    } catch (e) {
      priced = { sets: [], total: 0 };
    }
    var html =
      "<h2>Your order</h2>" +
      priced.sets
        .map(function (ps, i) {
          return (
            '<div class="aob__summary-set"><strong>Set ' +
            (i + 1) +
            " · " +
            esc(state.sets[i].location.name) +
            "</strong>" +
            ps.lines
              .map(function (line) {
                return (
                  '<div class="aob__summary-row"><span>' +
                  esc(line.label) +
                  (line.detail ? " · " + esc(line.detail) : "") +
                  "</span><b>" +
                  money(line.price) +
                  "</b></div>"
                );
              })
              .join("") +
            "</div>"
          );
        })
        .join("");
    html +=
      '<div class="aob__summary-total" aria-live="polite"><span>Total</span><span>' +
      money(priced.total) +
      "</span></div>";
    if (data.settings.showPaymentNote)
      html += '<p class="aob__payment-note">' + esc(data.settings.checkoutNote) + "</p>";
    if (state.checkoutError) html += '<p class="aob__checkout-error" role="alert">' + esc(state.checkoutError) + "</p>";
    html +=
      '<button type="button" class="aob__checkout" data-checkout ' +
      (state.busy || data.settings.missingProducts ? "disabled" : "") +
      ">" +
      (state.busy ? "Preparing checkout…" : "Continue to checkout") +
      '</button><button type="button" class="aob__start-over" data-start-over>Start over</button>';
    summaryNode.innerHTML = html;
    root.querySelector("[data-aob-mobile-total]").textContent = money(priced.total);
    root.querySelector("[data-aob-mobile-checkout]").disabled = state.busy || !!data.settings.missingProducts;
  }
  function render(all) {
    if (all) {
      renderLocationCards();
      renderSets();
    }
    renderSummary();
  }
  function updateLimit(index) {
    var set = state.sets[index],
      message = root.querySelector('[data-tile-limit="' + index + '"]'),
      previewNode = root.querySelector('[data-preview="' + index + '"]');
    if (!set || !message || !previewNode) return;
    var over = set.location.max_tiles && Core.tileCount(set) > set.location.max_tiles;
    message.textContent = over ? "This location fits up to " + set.location.max_tiles + " tiles." : "";
    previewNode.classList.toggle("is-over-limit", !!over);
  }
  function updateAllLimits() {
    state.sets.forEach(function (_, index) {
      updateLimit(index);
    });
  }
  function updateSetVisual(index) {
    var oldPreview = root.querySelector('[data-preview="' + index + '"]');
    if (!oldPreview) return;
    var holder = document.createElement("div");
    holder.innerHTML = preview(state.sets[index], index);
    oldPreview.replaceWith(holder.firstElementChild);
    fitPreviews();
    updateLimit(index);
    renderSummary();
    persist();
  }
  function openPicker(button) {
    pickerTarget = {
      set: Number(button.dataset.set),
      side: button.dataset.side,
    };
    pickerTrigger = button;
    var current = state.sets[pickerTarget.set][pickerTarget.side];
    root.querySelector("[data-aob-picker-side]").textContent =
      pickerTarget.side === "left" ? "Left of number" : "Right of number";
    root.querySelector("[data-aob-picker-grid]").innerHTML =
      '<button type="button" class="aob__picker-option" data-picker-logo="none" aria-pressed="' +
      (current.type === "none") +
      '"><span>No logo</span></button>' +
      data.logos
        .map(function (logo, index) {
          return (
            '<button type="button" class="aob__picker-option" data-picker-logo="' +
            index +
            '" aria-pressed="' +
            (current.type === "logo" && current.name === logo.name) +
            '"><img src="' +
            esc(logo.image) +
            '" alt=""><span>' +
            esc(logo.name) +
            "</span></button>"
          );
        })
        .join("");
    root.querySelector("[data-aob-picker-error]").hidden = true;
    picker.showModal();
  }
  function closePicker() {
    picker.close();
    var target = pickerTrigger;
    pickerTarget = null;
    pickerTrigger = null;
    if (target && document.contains(target)) target.focus();
  }
  function applyPickerChoice(slot) {
    var target = pickerTarget;
    if (!target) return;
    var previous = state.sets[target.set][target.side];
    if (slot.type !== "none" && previous && previous.type !== "none") slot.qty = Core.logoQty(previous);
    state.sets[target.set][target.side] = slot;
    picker.close();
    renderSets();
    renderSummary();
    persist();
    var next = root.querySelector('[data-choose-logo][data-set="' + target.set + '"][data-side="' + target.side + '"]');
    pickerTarget = null;
    pickerTrigger = null;
    if (next) next.focus();
  }
  function persist() {
    try {
      localStorage.setItem(
        DRAFT_KEY,
        JSON.stringify({
          note: state.note,
          sets: state.sets.map(function (s) {
            return {
              location: s.location.name,
              number: s.number,
              background: s.background === "none" ? "none" : s.background.name,
              left: serialSlot(s.left),
              right: serialSlot(s.right),
              direction: s.direction,
              mounting: s.mounting,
            };
          }),
        }),
      );
    } catch (_) {}
  }
  function serialSlot(s) {
    return !s || s.type === "none"
      ? { type: "none" }
      : s.type === "custom"
        ? { type: "none", lost: true }
        : { type: "logo", name: s.name, qty: Core.logoQty(s) };
  }
  function restore() {
    try {
      var saved = JSON.parse(localStorage.getItem(DRAFT_KEY));
      if (!saved || !Array.isArray(saved.sets)) return;
      var lost = false;
      state.note = saved.note || "";
      state.sets = saved.sets
        .map(function (s) {
          var location = data.locations.find(function (x) {
            return x.name === s.location;
          });
          if (!location) return null;
          var out = freshSet(location, s.number);
          out.background =
            s.background === "none"
              ? "none"
              : data.backgrounds.find(function (x) {
                  return x.name === s.background;
                }) || "none";
          ["left", "right"].forEach(function (side) {
            var old = s[side];
            if (old && old.lost) lost = true;
            var logo =
              old &&
              data.logos.find(function (x) {
                return x.name === old.name;
              });
            out[side] = logo ? { type: "logo", name: logo.name, image: logo.image, qty: old.qty } : { type: "none" };
          });
          out.direction = s.direction || "";
          out.mounting = s.mounting || "";
          return sanitizeSet(out, location);
        })
        .filter(Boolean);
      if (lost) state.checkoutError = "Custom logo files cannot be restored. Please choose them again.";
    } catch (_) {}
  }
  function changeAndRender() {
    persist();
    renderSets();
    renderSummary();
    root.querySelector("[data-aob-note]").value = state.note;
  }
  root.addEventListener("click", function (event) {
    var button = event.target.closest("button");
    if (!button) return;
    if (button.dataset.action === "select") {
      var loc = data.locations[Number(button.dataset.location)],
        old = state.sets[0];
      state.sets[0] = sanitizeSet(old, loc);
      mainGrid.querySelectorAll("[data-action='select']").forEach(function (locationButton) {
        locationButton.setAttribute("aria-pressed", String(locationButton === button));
      });
      changeAndRender();
      button.focus();
    }
    if (button.dataset.action === "add") {
      state.sets.push(freshSet(data.locations[Number(button.dataset.location)], state.sets[0] && state.sets[0].number));
      changeAndRender();
    }
    if (button.dataset.remove) {
      state.sets.splice(Number(button.dataset.remove), 1);
      changeAndRender();
    }
    if (button.matches("[data-choose-logo]")) openPicker(button);
    if (button.dataset.logoQty) {
      var qSet = Number(button.dataset.set),
        qSide = button.dataset.side,
        slot = state.sets[qSet][qSide];
      slot.qty = Math.min(Core.MAX_LOGO_QTY, Math.max(1, Core.logoQty(slot) + Number(button.dataset.logoQty)));
      changeAndRender();
      var again = root.querySelector(
        '[data-logo-qty="' + button.dataset.logoQty + '"][data-set="' + qSet + '"][data-side="' + qSide + '"]',
      );
      var fallback = root.querySelector('[data-choose-logo][data-set="' + qSet + '"][data-side="' + qSide + '"]');
      (again && !again.disabled ? again : fallback).focus();
    }
    if (button.matches("[data-picker-logo]")) {
      if (button.dataset.pickerLogo === "none") applyPickerChoice({ type: "none" });
      else {
        var l = data.logos[Number(button.dataset.pickerLogo)];
        applyPickerChoice({ type: "logo", name: l.name, image: l.image });
      }
    }
    if (button.matches("[data-aob-picker-close]")) closePicker();
    if (button.matches("[data-checkout]")) checkout();
    if (button.matches("[data-aob-mobile-checkout]")) {
      summaryNode.scrollIntoView({
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      });
      checkout();
    }
    if (button.matches("[data-start-over]")) {
      if (window.confirm("Clear your address tile design and start over?")) {
        state = { sets: [], note: "", checkoutError: "", busy: false };
        try {
          localStorage.removeItem(DRAFT_KEY);
        } catch (_) {}
        render(true);
      }
    }
  });
  root.addEventListener("input", function (event) {
    if (event.target.matches("[data-number]")) {
      var i = Number(event.target.dataset.number),
        val = event.target.value.replace(/\D/g, "").slice(0, 6);
      event.target.value = val;
      state.sets[i].number = val;
      updateSetVisual(i);
    }
    if (event.target.matches("[data-aob-note]")) {
      state.note = event.target.value;
      persist();
    }
  });
  root.addEventListener("change", function (event) {
    if (event.target.matches("[data-aob-picker-upload]")) {
      handleFile(event.target);
      return;
    }
    var m = (event.target.name || "").match(/^(background|direction|mounting)-(\d+)$/);
    if (!m) return;
    var set = state.sets[Number(m[2])];
    if (m[1] === "background") {
      set.background = event.target.value === "none" ? "none" : data.backgrounds[Number(event.target.value)];
    } else {
      set[m[1]] = event.target.value;
    }
    updateSetVisual(Number(m[2]));
  });
  function handleFile(input) {
    var file = input.files[0],
      error = root.querySelector("[data-aob-picker-error]");
    if (!file || !pickerTarget) return;
    var allowed = file.type.indexOf("image/") === 0 || file.type === "application/pdf" || /\.pdf$/i.test(file.name);
    if (!allowed) {
      error.textContent = "Choose an image or PDF file.";
      error.hidden = false;
      showSlotUploadError("Choose an image or PDF file.");
      input.value = "";
      return;
    }
    if (file.size > Number(data.settings.maxUploadMB) * 1024 * 1024) {
      error.textContent = "That file is too large. Choose a file up to " + data.settings.maxUploadMB + " MB.";
      error.hidden = false;
      showSlotUploadError(error.textContent);
      input.value = "";
      return;
    }
    var preview = "";
    if (file.type.indexOf("image/") === 0) {
      preview = URL.createObjectURL(file);
      fileUrls.push(preview);
    }
    applyPickerChoice({
      type: "custom",
      name: file.name,
      file: file,
      preview: preview,
    });
  }
  function showSlotUploadError(message) {
    if (!pickerTarget) return;
    var slotError = root.querySelector('[data-error-for="sets.' + pickerTarget.set + "." + pickerTarget.side + '"]');
    if (slotError) {
      slotError.textContent = message;
      slotError.hidden = false;
    }
  }
  function showErrors(errors) {
    root.querySelectorAll(".aob__error").forEach(function (x) {
      x.hidden = true;
    });
    if (!errors.length) return true;
    errors.forEach(function (e) {
      root.querySelectorAll('[data-error-for="' + e.path + '"]').forEach(function (n) {
        n.hidden = false;
        n.textContent = e.message;
      });
    });
    var target = root.querySelector('[data-error-for="' + errors[0].path + '"]');
    if (target) {
      target.hidden = false;
      target.scrollIntoView({
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "center",
      });
      var focus = target.parentElement.querySelector("input,button");
      if (focus) focus.focus({ preventScroll: true });
    }
    return false;
  }
  async function checkout() {
    state.checkoutError = "";
    var errors = Core.validate(state.sets, {
      perFileMB: Number(data.settings.maxUploadMB),
    });
    if (!showErrors(errors)) {
      renderSummary();
      return;
    }
    state.busy = true;
    renderSummary();
    try {
      var result = await window.AOBuilderCart.checkout({
        core: Core,
        sets: state.sets,
        products: data.products,
        note: state.note,
      });
      if (result.priceChanged) {
        try {
          sessionStorage.setItem("ao-builder-price-change", "1");
        } catch (_) {}
        window.location.reload();
        return;
      }
      try {
        localStorage.removeItem(DRAFT_KEY);
      } catch (_) {}
      window.location = "/checkout";
    } catch (error) {
      state.checkoutError =
        error.status === 413 ? "That file is too large." : error.message || "Something went wrong. Please try again.";
    } finally {
      state.busy = false;
      renderSummary();
    }
  }
  restore();
  try {
    if (sessionStorage.getItem("ao-builder-price-change")) {
      sessionStorage.removeItem("ao-builder-price-change");
      state.checkoutError = "Prices just changed, please review.";
    }
  } catch (_) {}
  render(true);
  root.querySelector("[data-aob-note]").value = state.note;
  // Keep the desktop order summary just below the theme's sticky header.
  function setStickyTop() {
    var header = document.querySelector("#shopify-section-header");
    var top = 24;
    if (header) {
      var position = getComputedStyle(header).position;
      if (position === "sticky" || position === "fixed") top = Math.round(header.getBoundingClientRect().height) + 20;
    }
    root.style.setProperty("--aob-sticky-top", top + "px");
  }
  setStickyTop();
  window.addEventListener("resize", setStickyTop);
  if (window.ResizeObserver) new ResizeObserver(fitPreviews).observe(setsNode);
  else window.addEventListener("resize", fitPreviews);
  window.addEventListener("beforeunload", function () {
    fileUrls.forEach(function (url) {
      URL.revokeObjectURL(url);
    });
  });
})();
